import { ClockCircleOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Col, Row, Typography, Card, Skeleton } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { Company, EventRegistrationStatus, Location } from "@bindeleddet/core/types";
import dayjs from "dayjs";
import { CompanyLogo } from "@bindeleddet/core/components";
import { message } from "@bindeleddet/core/utils";
import { StyledTitle } from "./style";
import EventStatus from "./EventStatus/EventStatus";

const { Paragraph } = Typography;

interface Props {
  id: number;
  title: string;
  location: Location | null | undefined;
  time: string;
  date: string;
  company: Company;
  registrationStatus: EventRegistrationStatus | null;
}

const SingleEventBox: React.FC<Props> = ({ id, title, location, time, date, company, registrationStatus }) => {
  const { currentUser } = useLoginContext();
  const eventPath = `/events/${id}/`;

  const handleEventClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!currentUser) {
      event.preventDefault();
      return message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    }
    if (isCompanyUser(currentUser) && company.id !== currentUser.id) {
      event.preventDefault();
      return message("error", "Bedrifter kan kun åpne egne arrangementer");
    }
  };

  return (
    <>
      <Link
        to={eventPath}
        onClick={handleEventClick}
        style={{ display: "block", color: "inherit", textDecoration: "none" }}
      >
        <Card hoverable bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }}>
          <Row>
            <Col span={4}>
              {company ? <CompanyLogo size="100%" companyId={company.id} src={company.logo} /> : <Skeleton.Image />}
            </Col>
            <Col
              span={17}
              style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
            >
              <Row>
                <EventStatus status={registrationStatus} />
              </Row>
              <Row>
                <StyledTitle level={4}>{title}</StyledTitle>
              </Row>
              <Row>
                <Col xs={0} sm={12}>
                  <EnvironmentOutlined style={{ marginRight: "0.4em" }} />
                  {!location?.name ? "Ikke bestemt" : location.name}
                </Col>
                <Col xs={24} sm={12}>
                  <ClockCircleOutlined style={{ marginRight: "0.4em" }} />
                  kl. {time}
                </Col>
              </Row>
            </Col>
            <Col span={3} style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
              <div style={{ textAlign: "center", lineHeight: "100%" }}>
                <Paragraph style={{ fontSize: "1.3em", marginBottom: "0.6em" }}>
                  {dayjs(date).format("MMM").toUpperCase().slice(0, -1)}
                </Paragraph>
                <Paragraph style={{ fontSize: "2.3em", margin: "0", paddingTop: "0" }}>
                  {dayjs(date).format("DD")}
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Card>
      </Link>
    </>
  );
};

export default SingleEventBox;
